'use strict';

export default class RentOfferCalc {
	constructor() {
		this.root = document.querySelector('[data-rent-calc]');
		if (!this.root) return false;
		this.prices = JSON.parse(this.root.dataset.rentCalc);


		this._matchHTML();
		this._initFields();
		this._calc();
		this._handler();
	}

	_matchHTML() {
		this.rentType = this.root.querySelector('[data-rent-type]');
		this.rentTerm = this.root.querySelector('[data-rent-term]');
		this.rentCount = this.root.querySelector('[data-rent-count]');
		this.rentTotal = this.root.querySelector('[data-rent-total]');
	}

	_initFields() {
		let type = this.rentType.value,
			term = +this.rentTerm.value,
			count = +this.rentCount.value;

		if (type === 'hours') {
			this.rentTerm.min = 2;
			this.rentTerm.max = 23;
			this.rentTerm.value = 2;
		} else if (type === 'days') {
			this.rentTerm.min = 1;
			this.rentTerm.max = 365;
			this.rentTerm.value = 1;
		}
	}

	_calc() {
		let type = this.rentType.value,
			term = +this.rentTerm.value,
			count = +this.rentCount.value,
			total = 0;

		if (count>this.rentCount.max)
			count=parseInt(this.rentCount.max)
		if (count<this.rentCount.min)
			count=parseInt(this.rentCount.min)
		if (term>this.rentTerm.max)
			term=parseInt(this.rentTerm.max)
		if (term<this.rentTerm.min)
			term=parseInt(this.rentTerm.min)

		if (type === 'hours') {
			total = (term * count) * this.prices.price1;
		} else if (type === 'days') {
			let price = 0;

			if (term === 1) {
				price = this.prices.price2;
			} else if ((2 <= term) && (term <= 4)){
				price = this.prices.price3;
			} else if (term >= 5){
				price = this.prices.price4;
			}
			total = (term * count) * price;
		}
		this.rentTotal.innerHTML = total;
	}

	_handler() {
		$(this.rentType).on('change', e => {
			this._initFields();
			this._calc();
		})

		let arr = [this.rentTerm, this.rentCount];

		arr.forEach(el => {
			el.addEventListener('change', e => {
				this._calc();
			})
		})
	}
}
